<div class="menu-container">
  @defer {
  <mat-tree
    id="main-menu"
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    class="example-tree">
    <mat-tree-node
      [routerLink]="node.routerLink ? node.routerLink : null"
      [class.active]="isActiveRoute(node)"
      [class.navigating]="isNavigatingTo(node)"
      [attr.aria-busy]="isNavigatingTo(node) ? true : null"
      [ngClass]="{
          'no-expanded-node': !isExpanded,
          disabled: !node.enabled,
          hidden: node.hidden,
        }"
      *matTreeNodeDef="let node"
      (click)="onMenuNavigate(node); closeMenu()"
      matTreeNodeToggle>
      <div
        class="menu-item"
        (click)="collapseNotChildNotParent(node)"
        [class.disabled]="!node.enabled"
        [ngClass]="{ 'no-expanded-menu-item': !isExpanded }">
        @if (node.icon) {
        <span class="material-symbols-rounded">{{ node.icon }}</span>
        }
        <a
          appTooltipEllipsis
          (appTruncateTextChange)="appTruncateText = $event"
          [matTooltip]="appTruncateText ? node.name : ''"
          >{{ node.name }}</a
        >
      </div>
    </mat-tree-node>
    <mat-nested-tree-node
      [routerLink]="node.routerLink ? node.routerLink : null"
      [class.active]="isActiveRoute(node) || isChildActive(node)"
      [class.navigating]="isNavigatingTo(node)"
      [attr.aria-busy]="isNavigatingTo(node) ? true : null"
      [class.disabled]="!node.enabled"
      *matTreeNodeDef="let node; when: hasChild"
      [ngClass]="{
          'no-expanded-node': !isExpanded,
          'expanded-button': treeControl.isExpanded(node),
          hidden: node.hidden,
          'active-parent-expand-button':
            isChildActive(node) && treeControl.getDescendants(node).length > 0,
        }"
      (click)="onMenuNavigate(node)"
      matTreeNodeToggle>
      <div
        class="mat-tree-node"
        (click)="collapseExpandSelect(node)"
        [class.disabled]="!node.enabled">
        <div
          class="menu-item"
          (click)="collapseExpandSelect(node)"
          [class.disabled]="!node.enabled"
          [ngClass]="{
              'no-expanded-menu-item': !isExpanded,
              'active-parent':
                isChildActive(node) &&
                this.treeControl.getDescendants(node).length > 0,
            }">
          @if (node.icon) {
          <span class="material-symbols-rounded">{{ node.icon }}</span>
          }
          <a
            appTooltipEllipsis
            (appTruncateTextChange)="appTruncateText = $event"
            [matTooltip]="appTruncateText ? node.name : ''"
            [routerLink]="node.routerLink ? node.routerLink : null"
            >{{ node.name }}</a
          >
        </div>
        <span class="example-spacer"></span>
        <button
          mat-icon-button
          [attr.aria-label]="'Toggle ' + node.name"
          (click)="collapseExpandSelect(node)">
          <mat-icon class="material-symbols-rounded">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
      </div>
      <div
        [@expandCollapse]="
            treeControl.isExpanded(node) ? 'expanded' : 'collapsed'
          "
        role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
  } @placeholder (minimum 400ms) {
  <div style="padding: 10px">
    <app-skeleton-menu-item></app-skeleton-menu-item>
  </div>
  }
</div>
